import type { UserMode } from '@respiria/shared';

/**
 * Coach-mark tours, one per user modality (issue #57). Each step either spotlights
 * an element (by its `data-tour` attribute) or, with no `target`, shows a centered
 * card. If a target isn't on screen (e.g. previewing another modality's tour from
 * Settings), the overlay degrades that step to a centered card, so a tour never
 * breaks. Copy is i18n via `t()`; Spanish is the baseline, the rest fall back.
 */
export type TourStep = {
  target?: string;
  titleKey: string;
  bodyKey: string;
};

export const TOUR_MODES: UserMode[] = ['smoking', 'quitting', 'maintaining'];

export const TOURS: Record<UserMode, TourStep[]> = {
  smoking: [
    { titleKey: 'tour.smoking.intro.title', bodyKey: 'tour.smoking.intro.body' },
    { target: 'tour-hero', titleKey: 'tour.smoking.hero.title', bodyKey: 'tour.smoking.hero.body' },
    { target: 'tour-quitday', titleKey: 'tour.smoking.quitday.title', bodyKey: 'tour.smoking.quitday.body' },
    { target: 'tour-craving', titleKey: 'tour.smoking.craving.title', bodyKey: 'tour.smoking.craving.body' },
    { target: 'tour-tab-more', titleKey: 'tour.smoking.more.title', bodyKey: 'tour.smoking.more.body' },
    { titleKey: 'tour.outro.title', bodyKey: 'tour.outro.body' },
  ],
  quitting: [
    { titleKey: 'tour.quitting.intro.title', bodyKey: 'tour.quitting.intro.body' },
    { target: 'tour-hero', titleKey: 'tour.quitting.hero.title', bodyKey: 'tour.quitting.hero.body' },
    { target: 'tour-treatment', titleKey: 'tour.quitting.treatment.title', bodyKey: 'tour.quitting.treatment.body' },
    { target: 'tour-checkin', titleKey: 'tour.quitting.checkin.title', bodyKey: 'tour.quitting.checkin.body' },
    { target: 'tour-craving', titleKey: 'tour.quitting.craving.title', bodyKey: 'tour.quitting.craving.body' },
    { target: 'tour-money', titleKey: 'tour.quitting.money.title', bodyKey: 'tour.quitting.money.body' },
    { target: 'tour-tab-progress', titleKey: 'tour.quitting.progress.title', bodyKey: 'tour.quitting.progress.body' },
    { titleKey: 'tour.outro.title', bodyKey: 'tour.outro.body' },
  ],
  maintaining: [
    { titleKey: 'tour.maintaining.intro.title', bodyKey: 'tour.maintaining.intro.body' },
    { target: 'tour-hero', titleKey: 'tour.maintaining.hero.title', bodyKey: 'tour.maintaining.hero.body' },
    { target: 'tour-craving', titleKey: 'tour.maintaining.craving.title', bodyKey: 'tour.maintaining.craving.body' },
    { target: 'tour-tab-health', titleKey: 'tour.maintaining.health.title', bodyKey: 'tour.maintaining.health.body' },
    { target: 'tour-tab-progress', titleKey: 'tour.maintaining.progress.title', bodyKey: 'tour.maintaining.progress.body' },
    { titleKey: 'tour.outro.title', bodyKey: 'tour.outro.body' },
  ],
};
